<template>
  <div class="page workflow">
    <div class="page-top">
      <div @click="$router.go(-1)" class="c-pointer">
        <i class="el-icon-arrow-left m-r-5"></i>
        <span>{{ templateTypeTitle }}</span>
        /
        <span>{{ workflow.title }}</span>
      </div>
    </div>
    <div class="page-content">
      <div class="page-left">
        <template v-for="(item, i) in workflow.def.nodes">
          <div
            class="node"
            :class="activeI == i ? 'node-active' : ''"
            :key="i"
            @click="doEdit(item, i)"
          >
            <div class="node-step">
              <span v-if="item.disabled != 1">{{ i + 1 }}</span>
              <span v-else>
                <i class="el-icon-close"></i>
              </span>
            </div>
            <div class="node-info">
              <div class="node-name">{{ item.name }}</div>
              <div class="node-desc">{{ item.desc }}</div>
            </div>
            <div class="node-sort">
              <i class="el-icon-circle-plus-outline c-pointer" @click="doNew(i + 1)"></i>
            </div>
            <div class="node-close" v-if="!item.disableDelete" @click.stop="doRemove(item, i)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </template>
        <div style="margin-bottom: 30px;text-align: center">
          <el-button type="primary" round @click="doNew()">添加节点</el-button>
        </div>
      </div>
      <div class="page-right">
        <div>
          <div class="page-right-form">
            <div class="form-title">基本信息</div>
            <el-form
              :model="formData"
              :rules="this.$util.rules"
              ref="formData"
              label-width="130px"
              label-position="left"
            >
              <el-form-item label="节点名称">
                <el-input
                  v-model="formData.name"
                  placeholder="节点名称将显示在左侧节点框内"
                ></el-input>
              </el-form-item>
              <el-form-item label="节点说明">
                <el-input
                  v-model="formData.desc"
                  placeholder="节点说明将显示在左侧节点标题下方"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="page-right-form"
            v-if="
              osg.has('Workflows?templateType=TT2,nodeType') ||
                osg.has('Workflows?templateType=TT3,nodeType') ||
                formData.nodeType != 'accept'
            "
          >
            <div class="form-title">
              节点类型
            </div>
            <el-form
              :model="formData"
              :rules="this.$util.rules"
              ref="formData"
              label-width="130px"
              label-position="left"
            >
              <el-form-item
                label="节点类型"
                v-if="
                  osg.has('Workflows?templateType=TT2,nodeType') ||
                    osg.has('Workflows?templateType=TT3,nodeType')
                "
              >
                <el-select
                  v-model="formData.nodeType"
                  clearable
                  @change="
                    formData.hideNodeId = '';
                    formData.addProductShow = '';
                    formData.addFormCodeId = '';
                  "
                  placeholder="请选择节点功能 / 节点关联 / 节点执行"
                >
                  <el-option-group
                    v-for="group in options.nodeType"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in group.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item
                label="服务类型"
                v-if="formData.nodeType == 'dispatch' || formData.nodeType == 'allot'"
              >
                <el-select v-model="formData.serviceType" multiple clearable>
                  <el-option
                    v-for="item in options.serviceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="节点类型" v-show="false">
                <el-select v-model="formData.type" clearable>
                  <el-option
                    v-for="item in options.type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item
                label="资源类型"
                v-if="
                  formData.nodeType == 'allot' ||
                    formData.nodeType == 'dispatch' ||
                    (Array.isArray(formData.handleButtons) &&
                      formData.handleButtons.some(btn => {
                        return btn.show && (btn.action == 'allot' || btn.action == 'dispatch');
                      }))
                "
              >
                <el-select v-model="formData.resourceType" multiple clearable>
                  <el-option
                    v-for="item in options.resourceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="资源角色"
                v-if="
                  formData.resourceType &&
                    (formData.resourceType.indexOf('technician') != -1 ||
                      formData.resourceType.indexOf('dispatcher') != -1)
                "
              >
                <el-select v-model="formData.resourceRoles" multiple clearable>
                  <el-option
                    v-for="item in options.resourceRoles"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="资源是否允许多选" v-if="formData.nodeType == 'dispatch'">
                <el-radio-group v-model="formData.resourceMultiple" class="c-flex c-flex-center">
                  <el-radio :label="true">允许</el-radio>
                  <el-radio :label="false">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="关联表单"
                v-if="
                  formData.nodeType != 'sign' &&
                    formData.nodeType != 'placeOrder' &&
                    formData.nodeType != 'pay' &&
                    formData.nodeType != 'subflow' &&
                    formData.nodeType != 'subflows'
                "
              >
                <el-select
                  v-model="formData.formDefId"
                  @change="formDefIdChange"
                  @clear="
                    formData.formFieldIdsFill = [];
                    formData.formFieldIdsReadOnly = [];
                  "
                  clearable
                  placeholder="此节点如需填写表单 请选择"
                  filterable
                >
                  <el-option
                    v-for="item in options.formDefId"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <icon-park
                  type="view-list"
                  theme="outline"
                  size="14"
                  fill="#409EFF"
                  :strokeWidth="4"
                  style="vertical-align: middle;margin:0 3px 0 10px;"
                />
                <el-button
                  type="text"
                  style="vertical-align: middle;"
                  @click="osg.open('FormDesigner', { extId: formData.formDefId }, '_blank')"
                >
                  查看关联表单
                </el-button>
              </el-form-item>
              <el-form-item v-if="formData.formDefId">
                <span>
                  <icon-park
                    type="setting-two"
                    theme="outline"
                    size="14"
                    fill="#409EFF"
                    :strokeWidth="4"
                    style="vertical-align: middle;margin:0 3px 0 10px;"
                  />
                  <el-button
                    type="text"
                    style="vertical-align: middle;"
                    @click="openFormulaEditor('formInitFormula')"
                  >
                    表单初始化配置
                  </el-button>
                </span>
                <span style="margin-left:50px;">
                  <icon-park
                    type="setting-two"
                    theme="outline"
                    size="14"
                    fill="#409EFF"
                    :strokeWidth="4"
                    style="vertical-align: middle;margin:0 3px 0 10px;"
                  />
                  <el-button
                    type="text"
                    style="vertical-align: middle;"
                    @click="openFormulaEditor('formSubmitFormula')"
                  >
                    表单提交校验配置
                  </el-button>
                </span>
              </el-form-item>
              <el-form-item label="表单字段" v-if="formData.formDefId">
                <!-- <div v-for="(ffItem, ffIndex) in options.formFieldIds" :key="ffIndex">
                  {{ ffItem.nameDisp }}
                  <el-radio-group style="display:flex" v-model="ffItem.formFieldIdsData">
                    <el-radio :label="1">可编辑</el-radio>
                    <el-radio :label="2">只读</el-radio>
                    <el-radio :label="3">隐藏</el-radio>
                  </el-radio-group>
                </div> -->
                <el-table class="formField_wrapper" height="300" :data="options.formFieldIds">
                  <el-table-column prop="nameDisp" label="字段" width="100px"></el-table-column>
                  <el-table-column prop="ops" label="展示方式" width="260px">
                    <template slot-scope="scope">
                      <el-radio-group style="display:flex" v-model="scope.row.formFieldIdsVal">
                        <el-radio :label="1">可编辑</el-radio>
                        <el-radio :label="2">只读</el-radio>
                        <el-radio :label="3">隐藏</el-radio>
                      </el-radio-group>
                    </template>
                  </el-table-column>
                  <el-table-column prop="fieldFormula" label="公式编辑器">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        style="vertical-align: middle;"
                        @click="openFormulaEditor('fieldFormula', scope.row)"
                      >
                        插入公式
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>

                <!-- <el-transfer
                  v-model="formData.formFieldIdsReadOnly"
                  :data="options.formFieldIds"
                  :titles="['可编辑', '只读']"
                  :props="{
                    key: '_id',
                    label: 'nameDisp'
                  }"
                  @change="$forceUpdate()"
                ></el-transfer> -->
              </el-form-item>
              <!-- <el-form-item label="表单渲染类型">
              <el-select v-model="formData.formFillType" clearable>
                <el-option
                  v-for="item in options.formFillType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
              <el-form-item
                label="添加表单字典ID"
                v-if="
                  formData.nodeType == 'forms' &&
                    (osg.has('Workflows?templateType=TT2,nodeType') ||
                      osg.has('Workflows?templateType=TT3,nodeType'))
                "
              >
                <el-input
                  v-model="formData.addFormCodeId"
                  placeholder="字典表指定可以添加的表单"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="formData.nodeType == 'placeOrder' || formData.nodeType == 'forms'"
              >
                <template slot="label">
                  某节点完成时隐藏{{ formData.name }}节点
                </template>
                <el-select v-model="formData.hideNodeId" clearable placeholder="根据业务需要配置">
                  <el-option
                    v-for="item in workflow.def.nodes"
                    :key="item.nodeId"
                    :label="item.name"
                    :value="item.nodeId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="是否允许手动新建表单数据"
                v-if="formData.exts && formData.nodeType == 'repeat'"
              >
                <el-radio-group v-model="formData.exts.addBtnShow" class="c-flex c-flex-center">
                  <el-radio :label="1">允许</el-radio>
                  <el-radio :label="2">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="关联子流程"
                v-if="
                  formData.nodeType == 'placeOrder' ||
                    formData.nodeType == 'subflow' ||
                    formData.nodeType == 'subflows'
                "
              >
                <el-select v-model="formData.nodeTypeDef" filterable allow-create clearable>
                  <el-option
                    v-for="item in options.nodeTypeDef"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
                <icon-park
                  type="s-turn-left"
                  theme="outline"
                  size="14"
                  fill="#409EFF"
                  :strokeWidth="4"
                  style="vertical-align: middle;margin:0 3px 0 10px;"
                />
                <el-button
                  type="text"
                  style="vertical-align: middle;"
                  @click="osg.open('workflow', { id: formData.nodeTypeDef }, '_blank')"
                >
                  查看子流程
                </el-button>
              </el-form-item>
              <el-form-item label="是否允许手动添加流程" v-if="formData.nodeType == 'subflows'">
                <el-radio-group v-model="formData.addProductShow">
                  <el-radio :label="1">允许</el-radio>
                  <el-radio :label="2">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <div class="page-right-form">
            <div class="form-title">节点处理人</div>
            <el-form
              :model="formData"
              :rules="this.$util.rules"
              ref="formData"
              label-width="130px"
              label-position="left"
            >
              <el-form-item label="待处理用户类型">
                <el-select v-model="formData.userChooseRule" @change="userChooseChange" clearable>
                  <el-option
                    v-for="item in options.userChooseRule"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="待处理用户" v-if="formData.userChooseRule == 'user'">
                <el-select
                  v-model="formData.userChoose"
                  multiple
                  filterable
                  @change="$forceUpdate()"
                  placeholder="支持多选"
                >
                  <el-option
                    v-for="item in options.users"
                    :key="item._id"
                    :label="item.name"
                    :value="item._id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="待处理用户"
                v-if="formData.userChooseRule == 'role' || formData.userChooseRule == 'orgrole'"
              >
                <el-select
                  v-model="formData.userChoose"
                  multiple
                  filterable
                  @change="$forceUpdate()"
                  placeholder="支持多选"
                >
                  <el-option
                    v-for="item in options.roles"
                    :key="item._id"
                    :label="item.name"
                    :value="item._id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="待处理用户" v-if="formData.userChooseRule == 'org'">
                <el-cascader
                  :options="options.org"
                  :props="{
                    multiple: true,
                    checkStrictly: true,
                    children: 'orgList',
                    label: 'orgName',
                    value: '_id',
                    emitPath: false
                  }"
                  v-model="formData.userChoose"
                  @change="$forceUpdate()"
                  clearable
                  filterable
                  placeholder="支持多选"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="处理按钮" v-if="Array.isArray(formData.handleButtons)">
                <el-table :data="formData.handleButtons" style="width:400px !important">
                  <el-table-column prop="name" label="操作按钮" width="100px">
                    <template slot-scope="scope">
                      {{ scope.row.name }}
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.description"
                        placement="top"
                        v-if="scope.row.description"
                      >
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="text" label="显示名称" width="130px">
                    <template slot-scope="scope">
                      <el-input
                        placeholder="请输入显示名称"
                        suffix-icon="el-icon-edit"
                        v-model="scope.row.text"
                        size="mini"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="show" label="是否启用" width="100px">
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.show"
                        @change="scope.row.comment = scope.row.show"
                      ></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="comment" label="是否需要批语" width="100px">
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.comment"
                        @change="scope.row.comment ? (scope.row.show = true) : null"
                      ></el-switch>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="page-right-form"
            v-if="
              osg.has('Workflows?templateType=TT2,groovyScript') ||
                osg.has('Workflows?templateType=TT3,groovyScript')
            "
          >
            <div class="form-title">事件脚本</div>
            <el-form
              :model="formData"
              :rules="this.$util.rules"
              ref="formData"
              label-width="130px"
              label-position="left"
            >
              <el-form-item label="流程进入条件">
                <el-select
                  v-model="formData.routeInCondition"
                  filterable
                  allow-create
                  clearable
                  placeholder="满足此条件才会进入此节点"
                >
                  <el-option
                    v-for="(item, i) in options.groovyScript"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <icon-park
                  type="code"
                  theme="outline"
                  size="14"
                  fill="#409EFF"
                  :strokeWidth="4"
                  style="vertical-align: middle;margin:0 3px 0 10px;"
                />
                <el-button
                  type="text"
                  style="vertical-align: middle;"
                  @click="openFormulaEditor('routeInConditionFormula')"
                >
                  脚本编辑器
                </el-button>
              </el-form-item>
              <el-form-item label="前置动作脚本">
                <el-select
                  v-model="formData.preActionScript"
                  filterable
                  allow-create
                  clearable
                  placeholder="节点执行之前先执行的脚本"
                >
                  <template v-for="(item, i) in options.groovyScript">
                    <el-option
                      v-if="item.preAction"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </template>
                </el-select>
                <icon-park
                  type="code"
                  theme="outline"
                  size="14"
                  fill="#409EFF"
                  :strokeWidth="4"
                  style="vertical-align: middle;margin:0 3px 0 10px;"
                />
                <el-button
                  type="text"
                  style="vertical-align: middle;"
                  @click="openFormulaEditor('preActionScriptFormula')"
                >
                  脚本编辑器
                </el-button>
              </el-form-item>
              <el-form-item label="后置动作脚本">
                <el-select
                  v-model="formData.actionScript"
                  filterable
                  allow-create
                  clearable
                  placeholder="节点执行之后要执行的脚本"
                >
                  <template v-for="(item, i) in options.groovyScript">
                    <el-option
                      v-if="!item.preAction"
                      :key="i"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </template>
                </el-select>
                <icon-park
                  type="code"
                  theme="outline"
                  size="14"
                  fill="#409EFF"
                  :strokeWidth="4"
                  style="vertical-align: middle;margin:0 3px 0 10px;"
                />
                <el-button
                  type="text"
                  style="vertical-align: middle;"
                  @click="openFormulaEditor('actionScriptFormula')"
                >
                  脚本编辑器
                </el-button>
              </el-form-item>
              <el-form-item label="被回退动作脚本">
                <el-select v-model="formData.backScript" filterable allow-create clearable>
                  <el-option
                    v-for="(item, i) in options.groovyScript"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <icon-park
                  type="code"
                  theme="outline"
                  size="14"
                  fill="#409EFF"
                  :strokeWidth="4"
                  style="vertical-align: middle;margin:0 3px 0 10px;"
                />
                <el-button
                  type="text"
                  style="vertical-align: middle;"
                  @click="openFormulaEditor('backScriptFormula')"
                >
                  脚本编辑器
                </el-button>
              </el-form-item>
              <el-form-item label="退到的动作脚本">
                <el-select v-model="formData.backToScript" filterable allow-create clearable>
                  <el-option
                    v-for="(item, i) in options.groovyScript"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <icon-park
                  type="code"
                  theme="outline"
                  size="14"
                  fill="#409EFF"
                  :strokeWidth="4"
                  style="vertical-align: middle;margin:0 3px 0 10px;"
                />
                <el-button
                  type="text"
                  style="vertical-align: middle;"
                  @click="openFormulaEditor('backToScriptFormula')"
                >
                  脚本编辑器
                </el-button>
              </el-form-item>
              <!-- <el-form-item label="被回退动作脚本">
              <el-input type="textarea" v-model="formData.backScript"></el-input>
            </el-form-item>
            <el-form-item label="退到的动作脚本">
              <el-input type="textarea" v-model="formData.backToScript"></el-input>
            </el-form-item> -->
              <el-form-item label="是否允许撤回">
                <el-radio-group v-model="formData.takebackShow" class="c-flex c-flex-center">
                  <el-radio :label="1">允许</el-radio>
                  <el-radio :label="2">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否允许回退">
                <el-radio-group v-model="formData.rollbackShow" class="c-flex c-flex-center">
                  <el-radio :label="1">允许</el-radio>
                  <el-radio :label="2">不允许</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="page-right-form"
            v-if="
              osg.has('Workflows?templateType=TT2,sla') || osg.has('Workflows?templateType=TT3,sla')
            "
          >
            <div class="form-title">流程时效 SLA</div>
            <el-form
              :model="formData"
              :rules="this.$util.rules"
              ref="formData"
              label-width="130px"
              label-position="left"
            >
              <el-form-item label="超时 第1次提醒" class="form-item-sla">
                <el-input-number
                  v-model="formData.alertTypeCount"
                  :controls="false"
                  :precision="0"
                  :min="0"
                  placeholder="多久未处理 进行第1次提醒"
                  style="width:190px !important"
                ></el-input-number>
                <el-select
                  v-model="formData.alertType"
                  placeholder="时间单位"
                  clearable
                  style="width:100px !important;margin-left:10px"
                >
                  <el-option
                    v-for="item in options.alertType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <i
                  v-if="alertNum == 1"
                  class="el-icon-circle-plus c-pointer c_size_20 c_blue c_m_l_n"
                  @click="addSLA(1)"
                ></i>
              </el-form-item>
              <el-form-item label="超时 第2次提醒" v-if="alertNum >= 2">
                <el-input-number
                  v-model="formData.alertType2Count"
                  :controls="false"
                  :precision="0"
                  :min="0"
                  placeholder="多久未处理 进行第2次提醒"
                  style="width:190px !important"
                ></el-input-number>
                <el-select
                  v-model="formData.alertType2"
                  placeholder="时间单位"
                  clearable
                  style="width:100px !important;margin-left:10px"
                >
                  <el-option
                    v-for="item in options.alertType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <i
                  v-if="alertNum == 2"
                  class="el-icon-circle-plus c-pointer c_size_20 c_blue c_m_l_n"
                  @click="addSLA(2)"
                ></i>
                <i
                  v-if="alertNum == 2"
                  class="el-icon-remove c-pointer c_size_20 c_blue c_m_l_n c_red"
                  @click="removeSLA(2)"
                ></i>
              </el-form-item>
              <el-form-item label="超时 第3次提醒" v-if="alertNum == 3">
                <el-input-number
                  v-model="formData.alertType3Count"
                  :controls="false"
                  :precision="0"
                  :min="0"
                  placeholder="多久未处理 进行第3次提醒"
                  style="width:190px !important"
                ></el-input-number>
                <el-select
                  v-model="formData.alertType3"
                  placeholder="时间单位"
                  clearable
                  style="width:100px !important;margin-left:10px"
                >
                  <el-option
                    v-for="item in options.alertType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <i
                  class="el-icon-remove c-pointer c_size_20 c_blue c_m_l_n c_red"
                  @click="removeSLA(3)"
                ></i>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="page-right-form"
            v-if="
              osg.has('Workflows?templateType=TT2,control') ||
                osg.has('Workflows?templateType=TT3,control')
            "
          >
            <div class="form-title">
              消息通知
              <icon-park
                type="message-one"
                theme="outline"
                size="14"
                fill="#409EFF"
                :strokeWidth="4"
                style="vertical-align: middle;margin:0 3px 0 10px;"
              />
              <el-button
                type="text"
                style="vertical-align: middle;"
                @click="openFormulaEditor('notificationScriptFormula')"
              >
                通知编辑器
              </el-button>
            </div>
          </div>
          <div
            class="page-right-form"
            v-if="
              osg.has('Workflows?templateType=TT2,control') ||
                osg.has('Workflows?templateType=TT3,control') ||
                osg.has('Workflows?templateType=TT2,closeable') ||
                osg.has('Workflows?templateType=TT3,closeable')
            "
          >
            <div class="form-title">节点控制</div>
            <el-form
              :model="formData"
              :rules="this.$util.rules"
              ref="formData"
              label-width="220px"
              label-position="left"
            >
              <el-form-item
                :label="`是否允许删除${formData.name || '当前'}节点`"
                v-if="
                  osg.has('Workflows?templateType=TT2,deletable') ||
                    osg.has('Workflows?templateType=TT3,deletable')
                "
              >
                <el-switch
                  v-model="formData.disableDelete"
                  active-text="允许"
                  inactive-text="不允许"
                  :active-value="false"
                  :inactive-value="true"
                ></el-switch>
              </el-form-item>
              <el-form-item
                :label="`是否允许关闭${formData.name || '当前'}节点`"
                v-if="
                  osg.has('Workflows?templateType=TT2,closeable') ||
                    osg.has('Workflows?templateType=TT3,closeable')
                "
              >
                <el-switch
                  v-model="formData.closeable"
                  active-text="允许"
                  inactive-text="不允许"
                  @change="formData.disabled = 0"
                ></el-switch>
              </el-form-item>
              <el-form-item
                :label="`开启/关闭${formData.name || '当前'}节点`"
                v-if="formData.closeable"
              >
                <el-switch
                  v-model="formData.disabled"
                  active-text="开启"
                  inactive-text="关闭"
                  :active-value="0"
                  :inactive-value="1"
                  @change="$forceUpdate()"
                ></el-switch>
              </el-form-item>
              <el-form-item
                label="是否允许控制在小程序端的展示"
                v-if="
                  osg.has('Workflows?templateType=TT2,mpShowable') ||
                    osg.has('Workflows?templateType=TT3,mpShowable')
                "
              >
                <el-switch
                  v-model="formData.mpShowable"
                  active-text="允许"
                  inactive-text="不允许"
                  @change="formData.mpShow = 0"
                ></el-switch>
              </el-form-item>
              <el-form-item
                :label="`是否在小程序端始终展示${formData.name || '当前'}节点`"
                v-if="formData.mpShowable"
              >
                <el-switch
                  v-model="formData.mpShow"
                  active-text="始终展示"
                  inactive-text="按权限展示"
                  :active-value="1"
                  :inactive-value="0"
                  @change="$forceUpdate()"
                ></el-switch>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-dialog
          title="公式编辑器"
          :visible.sync="editor.show"
          @close="editor.visible = false"
          class="c-dialog"
        >
          <div
            class="editor-upper"
            :style="'visibility:' + (editor.visible ? 'visible' : 'hidden')"
          >
            <codemirror
              ref="codemirror"
              v-model="editor.value"
              :options="editor.cmOptions"
              style="height:150px"
            ></codemirror>
          </div>
          <div class="editor-lower">
            <div class="editor-value">
              <span>可用变量</span>
              <div>
                <el-input
                  prefix-icon="el-icon-search"
                  v-model="editor.searchField"
                  clearable
                  placeholder="搜索变量"
                ></el-input>
                <el-collapse v-model="editor.activeName" accordion>
                  <template v-for="item in editor.variableList">
                    <el-collapse-item
                      v-if="
                        editor.searchField
                          ? item.children.some(f => f.nameDisp.indexOf(editor.searchField) != -1)
                          : true
                      "
                      :key="item.nodeId"
                      :title="item.nodeName + '·' + item.formName"
                      :name="item.nodeId"
                    >
                      <template v-for="field in item.children">
                        <div
                          v-if="
                            editor.searchField
                              ? field.nameDisp.indexOf(editor.searchField) != -1
                              : true
                          "
                          :key="field._id"
                          @click="
                            insertValue({
                              label: `${item.nodeName}.${field.nameDisp}`,
                              value: `$${item.nodeId}.${field.preset ? '' : 'exts.'}${field.name}#`
                            })
                          "
                          class="editor-value-item"
                        >
                          <span>{{ field.nameDisp }}</span>
                          <el-tag size="mini">{{ osg.codelabel('fieldType', field.type) }}</el-tag>
                        </div>
                      </template>
                    </el-collapse-item>
                  </template>
                </el-collapse>
              </div>
            </div>
            <!-- <div class="editor-template">
              <span>通知模板</span>
              <div></div>
            </div> -->
            <div class="editor-value">
              <span>函数</span>
              <div>
                <el-input
                  prefix-icon="el-icon-search"
                  v-model="editor.searchFunction"
                  clearable
                  placeholder="搜索函数"
                ></el-input>
                <el-collapse v-model="editor.activeFunctions" accordion>
                  <template v-for="(value, key, index) in editor.functionGroup">
                    <el-collapse-item
                      v-if="
                        editor.searchFunction
                          ? value.some(
                              f =>
                                f.name.indexOf(editor.searchFunction) != -1 ||
                                f.tag.indexOf(editor.searchFunction) != -1
                            )
                          : true
                      "
                      :key="index"
                      :title="osg.codelabel('functionGroup', key)"
                      :name="key"
                    >
                      <template v-for="item in value">
                        <div
                          v-if="
                            editor.searchFunction
                              ? item.name.indexOf(editor.searchFunction) != -1 ||
                                item.tag.indexOf(editor.searchFunction) != -1
                              : true
                          "
                          :key="item._id"
                          @click="insertFormula(item.tag)"
                          @mouseover="editor.hoverFunction = item"
                          class="editor-value-item"
                        >
                          <span>{{ item.name }}</span>
                        </div>
                      </template>
                    </el-collapse-item>
                  </template>
                </el-collapse>
              </div>
            </div>
            <div class="editor-value c-flex-1">
              <span>使用说明</span>
              <div>
                <div class="function-name">{{ editor.hoverFunction.name || '' }}</div>
                <div class="c-p-10" v-html="editor.hoverFunction.annotate || ''"></div>
              </div>
            </div>
          </div>
          <span slot="footer" class="c-flex c-flex-between">
            <div>
              <el-popover placement="bottom" trigger="click" :content="editor.value" width="300">
                <el-button slot="reference">查看代码</el-button>
              </el-popover>
            </div>
            <div>
              <el-button
                @click="
                  editor.show = false;
                  editor.visible = false;
                "
              >
                取 消
              </el-button>
              <el-button type="primary" @click="editorSave">确 定</el-button>
            </div>
          </span>
        </el-dialog>
        <div class="page-right-btns">
          <el-button type="primary" @click="doSave">确认</el-button>
          <el-button @click="doInit">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'workflow',
  components: {
    codemirror
  },
  data() {
    return {
      tenantId: '',
      rules: this.$util.rules,
      // 处理按钮
      handleButtons: [
        {
          action: 'agree',
          name: '同意',
          text: '通过',
          show: false,
          comment: false,
          description: '',
          icon: 'el-icon-check',
          type: 'primary',
          placeholder: '请输入意见（选填）'
        },
        {
          action: 'disagree',
          name: '拒绝',
          text: '拒绝',
          show: false,
          comment: false,
          description: '',
          icon: 'el-icon-close',
          type: 'danger',
          placeholder: '请输入意见（必填）'
        },
        {
          action: 'takeback',
          name: '撤回',
          text: '撤回',
          show: false,
          comment: false,
          description: '撤回下一节点到当前节点，当下一节点未处理时可撤回。',
          icon: 'el-icon-refresh-left',
          type: '',
          placeholder: '请输入撤回理由（必填）'
        },
        {
          action: 'crossNodeTakeback',
          name: '跨节点撤回',
          text: '跨节点撤回',
          show: false,
          comment: false,
          description: '撤回后面的多个节点到当前节点。',
          icon: 'el-icon-refresh-left',
          type: '',
          placeholder: '请输入撤回理由（必填）'
        },
        {
          action: 'rollback',
          name: '退回',
          text: '退回',
          show: false,
          comment: false,
          description: '退回当前节点到上一节点，当前节点未处理时可退回。',
          icon: 'el-icon-refresh-left',
          type: '',
          placeholder: '请输入退回原因（必填）'
        },
        {
          action: 'crossNodeRollback',
          name: '跨节点退回',
          text: '跨节点退回',
          show: false,
          comment: false,
          description: '退回当前节点到指定节点，当前节点未处理时可退回。',
          icon: 'el-icon-refresh-left',
          type: '',
          placeholder: '请输入退回原因（必填）'
        },
        {
          action: 'allot',
          name: '分单',
          text: '分单',
          show: false,
          comment: false,
          description: '',
          icon: 'el-icon-position',
          type: 'warning',
          placeholder: ''
        },
        {
          action: 'dispatch',
          name: '派单',
          text: '派单',
          show: false,
          comment: false,
          description: '',
          icon: 'el-icon-s-promotion',
          type: 'warning',
          placeholder: ''
        },
        {
          action: 'accept',
          name: '接单',
          text: '接单',
          show: false,
          comment: false,
          description: '',
          icon: 'el-icon-document-checked',
          type: 'warning',
          placeholder: ''
        },
        {
          action: 'saveForm',
          name: '暂存表单',
          text: '暂存表单',
          show: false,
          comment: false,
          description: '',
          icon: 'el-icon-document-checked',
          type: 'success',
          placeholder: ''
        },
        {
          action: 'close',
          name: '关闭流程',
          text: '关闭流程',
          show: false,
          comment: false,
          description: '',
          icon: 'el-icon-circle-close',
          type: 'danger',
          placeholder: ''
        }
      ],
      options: {
        type: [
          { label: '节点', value: 'node' },
          { label: '串行多节点', value: 'hnodes', disabled: true },
          { label: '并行多节点', value: 'vnodes', disabled: true }
        ],
        nodeType: [
          {
            label: '节点功能',
            options: [
              {
                label: '分单',
                value: 'allot'
              },
              {
                label: '派单',
                value: 'dispatch'
              },
              {
                label: '接单',
                value: 'accept'
              },
              {
                label: '电子签约',
                value: 'sign'
              },
              {
                label: '下单',
                value: 'placeOrder'
              },
              {
                label: '电子支付',
                value: 'pay'
              }
            ]
          },
          {
            label: '节点关联',
            options: [
              {
                label: '关联1个表单，允许提交多条数据',
                value: 'repeat'
              },
              {
                label: '关联多个表单，允许提交多条数据',
                value: 'forms'
              },
              {
                label: '挂载1个子流程',
                value: 'subflow'
              },
              {
                label: '挂载多个子流程',
                value: 'subflows'
              }
            ]
          },

          {
            label: '节点执行',
            options: [
              {
                label: '自动执行，无需用户操作',
                value: 'auto'
              },
              {
                label: '禁止在小程序端操作',
                value: 'disable'
              }
            ]
          }
        ],
        // codecfg_formFillType: { codeId: 'formFillType' },
        codecfg_resourceType: { codeId: 'resourceType' },
        resourceType: [],
        codecfg_alertType: { codeId: 'alertType' },
        codecfg_resourceRoles: { codeId: 'resourceRoles' },
        codecfg_fieldType: { codeId: 'FIELD_TYPE' },
        codecfg_functionGroup: { codeId: 'functionGroup' },
        codecfg_serviceType: { codeId: 'serviceType' },
        //待处理用户类型
        userChooseRule: [
          { label: '发起人', value: 'starter' },
          { label: '用户', value: 'user' },
          { label: '组织', value: 'org' },
          { label: '角色', value: 'role' },
          { label: '数据所属组织下的角色', value: 'orgrole' }
        ],
        roles: [],
        //待处理用户（用户
        users: [],
        //关联子表单
        formDefId: [],
        //表单字段
        formFieldIds: [],
        //关联子流程
        nodeTypeDef: []
      },
      formData: {
        resourceType: [],
        takebackShow: 2,
        rollbackShow: 2,
        exts: {},
        handleButtons: this.$util.deepCopy(this.handleButtons)
      },
      workflow: {
        def: {
          type: 'hnodes', //node hnodes vnodes
          nodes: []
        }
      },
      activeI: 0, //点击的节点
      //标题
      templateTypeTitle: '',
      alertNum: 1, //控制流程时效SLA条数
      // 公式编辑器
      editor: {
        type: '',
        field: {}, //表单运行时字段公式
        show: false,
        visible: false,
        value: '',
        cm: null,
        cmOptions: {
          value: '', //编辑器的起始值。可以是字符串，也可以是文档对象。
          mode: 'text/javascript', //第一个将模式名称映射到它们的构造函数，第二个将MIME类型映射到模式规范。
          // theme: '', //编辑器样式的主题
          indentWithTabs: true, //在缩进时，是否tabSize 应该用N个制表符替换前N *个空格。默认值为false。
          smartIndent: true, //是否使用模式提供的上下文相关缩进（或者只是缩进与之前的行相同）。默认为true。
          lineNumbers: true, //是否在编辑器左侧显示行号。
          matchBrackets: true, //括号匹配
          autofocus: true, //可用于使CodeMirror将焦点集中在初始化上
          extraKeys: { 'Ctrl-Space': 'autocomplete' } //按键配置
        },
        variableList: [], //可用变量
        functionGroup: {}, //全部函数
        hoverFunction: {} //函数使用说明
      }
    };
  },
  mounted() {
    window.$this = this;
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.workflowId = this.osg.param('id');
    this.doInit();
    this.osg.codeoption(() => {
      this.getData();
    });
    this.getRoles();
    this.getUsers();
    this.getOrg();
    this.getForms(); //关联表单选项
    this.getWorkflows(); //关联子流程选项
  },
  computed: {
    codemirror() {
      return this.$refs.codemirror.codemirror;
    }
  },
  methods: {
    doInit() {
      this.formData = {
        resourceType: [],
        exts: {}, //待处理用户（角色）
        handleButtons: this.$util.deepCopy(this.handleButtons)
      };
      if (this.$refs.formData) {
        this.$refs.formData.resetFields();
      }
      this.activeI = 0;
      this.getData();
      this.getGroovyScript();
    },
    getData() {
      this.osg.ajax(`workflowDef/queryById/${this.workflowId}.do`, {}, res => {
        this.workflow = res.entity;
        switch (
          this.workflow.templateType //1,4,5在ext
        ) {
          case 'TT2':
            this.templateTypeTitle = '业务流程';
            break;
          case 'TT3':
            this.templateTypeTitle = '服务流程';
            break;
          default:
            this.templateTypeTitle = '工作流列表';
        }
        this.workflow.def.nodes = this.workflow.def.nodes || [];
        if (this.workflow.def.nodes.length == 0) {
          this.workflow.def.nodes.push(this.formData);
        } else {
          this.workflow.def.nodes[0].resourceType = this.workflow.def.nodes[0].resourceType || [];
          this.workflow.def.nodes[0].exts = this.workflow.def.nodes[0].exts || [];

          // 展示后续新支持的操作按钮
          let defaultHandleButtons = this.$util.deepCopy(this.handleButtons);
          let currentHandleButtons = this.workflow.def.nodes[0].handleButtons || [];
          for (let i = 0; i < defaultHandleButtons.length; i++) {
            for (let j = 0; j < currentHandleButtons.length; j++) {
              if (defaultHandleButtons[i].action == currentHandleButtons[j].action) {
                defaultHandleButtons[i] = currentHandleButtons[j];
                break;
              }
            }
          }
          this.workflow.def.nodes[0].handleButtons = defaultHandleButtons;
          // this.workflow.def.nodes[0].handleButtons || this.$util.deepCopy(this.handleButtons);

          this.formData = this.workflow.def.nodes[0];
        }
        //渲染只读、可填字段
        if (this.formData.formDefId) this.formDefIdChange(this.formData.formDefId);
        //渲染待处理用户
        for (var node of this.workflow.def.nodes || []) {
          if (node.userChooseRule && node.userChooseRule.indexOf(':') != -1) {
            node.userChoose = node.userChooseRule.split(':')[1].split(',');
            node.userChooseRule = node.userChooseRule.split(':')[0];
          }
        }
        this.$forceUpdate();
      });
    },
    doNew(i) {
      if (i) {
        this.workflow.def.nodes.splice(i, 0, {
          resourceType: [],
          takebackShow: 2,
          rollbackShow: 2,
          exts: {}
        });
      } else {
        this.workflow.def.nodes.push({
          resourceType: [],
          takebackShow: 2,
          rollbackShow: 2,
          exts: {}
        });
      }
      this.$forceUpdate();
    },
    doEdit(row, i) {
      if (row.nodeType == 'repeat') row.exts.addBtnShow = 1;
      row.resourceType = row.resourceType || [];
      row.exts = row.exts || {};

      // 展示后续新支持的操作按钮
      let defaultHandleButtons = this.$util.deepCopy(this.handleButtons);
      let currentHandleButtons = row.handleButtons || [];
      for (let i = 0; i < defaultHandleButtons.length; i++) {
        for (let j = 0; j < currentHandleButtons.length; j++) {
          if (defaultHandleButtons[i].action == currentHandleButtons[j].action) {
            defaultHandleButtons[i] = currentHandleButtons[j];
            break;
          }
        }
      }
      row.handleButtons = defaultHandleButtons;

      if (row.alertType3Count || row.alertType3Count == 0) {
        this.alertNum = 3;
      } else if (row.alertType2Count || row.alertType2Count == 0) {
        this.alertNum = 2;
      } else {
        this.alertNum = 1;
      }
      this.formData = row;
      this.activeI = i;
      this.formData.nodeId =
        this.formData.nodeId || (this.activeI + 1).toString() + new Date().getTime();

      if (this.formData.formDefId) this.formDefIdChange(this.formData.formDefId);
    },
    doSave() {
      //添加nodeId
      this.formData.nodeId =
        this.formData.nodeId || (this.activeI + 1).toString() + new Date().getTime();
      this.formData.exts = this.formData.exts || {};

      //填写只读字段
      if (this.formData.formDefId) {
        [
          this.formData.formFieldIdsReadOnly,
          this.formData.formFieldIdsHide,
          this.formData.formFieldIdsFill
        ] = [[], [], []];
        this.options.formFieldIds.forEach(item => {
          // 对表单字段的展示方式进行赋值
          switch ((item, item.formFieldIdsVal)) {
            case 2:
              this.formData.formFieldIdsReadOnly.push(item._id); // 只读
              break;
            case 3:
              this.formData.formFieldIdsHide.push(item._id); //隐藏
              break;
            default:
              this.formData.formFieldIdsFill.push(item._id); // 默认是可编辑
          }
        });
      }

      this.workflow.def.type = 'hnodes';

      //待处理人
      for (let node of this.workflow.def.nodes) {
        if (node.userChooseRule) {
          node.userChoose = node.userChoose || [];
          node.userChooseRule = node.userChooseRule || '';
          //类型:值逗号拼接
          if (node.userChooseRule && node.userChooseRule != 'starter') {
            node.userChooseRule = node.userChooseRule + ':' + node.userChoose.toString();
          }
        } else {
          node.userChoose = [];
        }
        node.type = node.type || 'node';
        node.formFieldIdsReadOnly = node.formFieldIdsReadOnly || [];

        // 默认允许撤回、回退
        node.takebackShow = node.takebackShow || '1';
        node.rollbackShow = node.rollbackShow || '1';
      }

      var params = {};
      params.workflowDef = JSON.stringify(this.workflow);
      if (this.osg.validate()) {
        this.osg.ajax('workflowDef/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doRemove(item, i) {
      this.osg.confirm(`是否确认删除${item.name ? '“' + item.name + '”' : ''}节点`, () => {
        this.workflow.def.nodes.splice(i, 1);
        if (i < this.activeI) {
          this.activeI--;
        } else if (i == this.activeI) {
          this.activeI = 0;
          this.formData = this.workflow.def.nodes[0] || {};
        }
        this.doSave();
      });
    },
    //关联表单
    getForms() {
      this.osg.ajax(
        'biz/ext/query.do',
        {
          'in:state|array-integer#and': '0,1',
          _all: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.title;
            item.value = item._id;
            if (item._id == this.workflow.formDefId) item.disabled = true;
          });
          this.options.formDefId = res.data;
        }
      );
    },
    //获取表单字段
    formDefIdChange(val) {
      if (!val) {
        this.formData.formFieldIdsFill = [];
        this.formData.formFieldIdsReadOnly = [];
        return;
      }
      this.osg.ajax(
        'biz/extField/query.do',
        {
          extId: val,
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.formData.formFieldIdsReadOnly = this.formData.formFieldIdsReadOnly || [];
          this.formData.formFieldIdsHide = this.formData.formFieldIdsHide || [];
          this.options.formFieldIds = res.data.map(fDitem => {
            // 对表单字段的展示方式进行赋值 formFieldIdsVal 1可编辑、2只读、3隐藏，默认是可编辑
            if (this.formData.formFieldIdsReadOnly.includes(fDitem._id)) {
              fDitem.formFieldIdsVal = 2;
            } else if (this.formData.formFieldIdsHide.includes(fDitem._id)) {
              fDitem.formFieldIdsVal = 3;
            } else {
              fDitem.formFieldIdsVal = 1;
            }
            return fDitem;
          });
        },
        { noload: true }
      );
    },
    //管理用户类型改变
    userChooseChange() {
      this.formData.userChoose = '';
    },
    //获取工作流程关联子流程
    getWorkflows() {
      this.osg.ajax(
        'workflowDef/query.do',
        { 'is:templateType|string#and': 'TT3', 'is:state|integer#and': 1 },
        res => {
          res.data.map(item => {
            item.label = item.title;
            item.value = item._id;
            if (item._id == this.workflow._id) item.disabled = true;
          });
          this.options.nodeTypeDef = res.data;
        }
      );
    },
    getRoles() {
      this.osg.ajax('role/query.do', { page: 1, rows: 100 }, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.roles = res.data;
      });
    },
    getUsers() {
      var params = {
        page: 1,
        rows: 100,
        tenantId: this.tenantId
      };
      this.osg.ajax('user/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.users = res.data;
      });
    },
    //获取组织
    getOrg() {
      this.osg.ajax('org/query.do', {}, res => {
        var obj = res.data;
        obj.orgName = '全部';
        this.options.org = [obj];
      });
    },
    //获取脚本规则
    getGroovyScript() {
      let params = {
        _all: '1',
        'is:type|integer#and': 0,
        'in:state|array-integer#and': '1'
      };
      this.osg.ajax('groovyScript/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item.scriptContent;
        });
        this.options.groovyScript = res.data;
      });
    },
    addSLA(i) {
      this.alertNum = i + 1;
    },
    removeSLA(i) {
      if (i == 3) {
        this.formData.alertType3Count = null;
        this.formData.alertType3 = '';
      } else if (i == 2) {
        this.formData.alertType2Count = null;
        this.formData.alertType2 = '';
      }
      this.alertNum = i - 1;
    },
    // 打开公式编辑器
    openFormulaEditor(type, field) {
      this.editor.type = type;
      if (field) {
        this.editor.value = field.fieldFormula || '';
        this.editor.field = field;
      } else {
        this.editor.value = this.formData[type] || '';
        this.editor.field = {};
      }
      this.editor.show = true;
      this.getAllExtFields();
      this.getFunctions();
    },
    // 获取所有变量（所有关联表单的节点及表单字段）
    getAllExtFields() {
      let variableList = [];
      this.workflow.def.nodes.map(node => {
        let obj = {};
        if (node.formDefId) {
          for (let i = 0; i < this.options.formDefId.length; i++) {
            if (node.formDefId == this.options.formDefId[i]._id) {
              obj.nodeId = node.nodeId || (this.activeI + 1).toString() + new Date().getTime();
              obj.nodeName = node.name;
              obj.formDefId = this.options.formDefId[i]._id;
              obj.formName = this.options.formDefId[i].title;
              obj.colName = this.options.formDefId[i].colName;
              obj.children = [];
              variableList.push(obj);
              break;
            }
          }
        }
      });
      if (variableList.length > 0) {
        this.osg.ajax(
          'biz/extField/query.do',
          {
            'in:extId|array#and': variableList.map(item => item.formDefId).join(),
            _all: '1',
            'is:state|integer#and': 1,
            sortField: 'extId,order',
            sortOrder: 'asc'
          },
          res => {
            res.data.map(item => {
              for (let i = 0; i < variableList.length; i++) {
                if (item.extId == variableList[i].formDefId) {
                  variableList[i].children.push(item);
                }
              }
            });
            this.editor.variableList = variableList;
            if (this.editor.value) {
              // 返显变量
              this.formatVariable();
            } else {
              this.editor.visible = true;
            }
          },
          { noload: true }
        );
      } else {
        this.editor.visible = true;
      }
    },
    // 获取函数
    getFunctions() {
      this.osg.ajax('definedFunction/queryDefinedFunctions.do', {}, res => {
        this.editor.functionGroup = res.data;
      });
    },
    // 插入变量
    insertValue({ label, value }) {
      //获取codemirror光标位置
      const pos1 = this.codemirror.getCursor();
      const pos2 = {};
      pos2.line = pos1.line;
      pos2.ch = pos1.ch;

      //制作标签dom(颜色样式自行设置)
      var dom = document.createElement('span');
      dom.className = 'cm-field';
      dom.innerHTML = label;

      const bookMark = value;
      const endPos = { line: pos2.line, ch: pos2.ch + bookMark.length };

      this.codemirror.replaceRange(bookMark, pos2); //先插入字符串再对插入字符串进行标签制定（其实就是在codemirror中动态添加标签）
      this.codemirror.markText(pos2, endPos, {
        replacedWith: dom
      });
      this.codemirror.focus();
    },
    // 插入公式
    insertFormula(name) {
      //获取codemirror光标位置
      const pos1 = this.codemirror.getCursor();
      const pos2 = {};
      pos2.line = pos1.line;
      pos2.ch = pos1.ch;
      this.codemirror.replaceRange(name + '()', pos2); //先插入字符串
      const pos = this.codemirror.getCursor();

      this.codemirror.setCursor({ line: pos.line, ch: pos.ch - 1 });
      this.codemirror.focus();
    },
    // 逐行返显变量
    formatVariable() {
      let lineCount = this.codemirror.lineCount();
      for (let line = 0; line < lineCount; line++) {
        let lineValue = this.codemirror.getLine(line);
        let regex = /\$[0-9a-zA-Z.]*#/g;
        let varStrArr = lineValue.match(regex);
        if (!varStrArr) break;
        let index = 0;
        varStrArr.map(varStr => {
          let ch = lineValue.indexOf(varStr, index); // 查找到变量$下标
          index = ch + varStr.length; // 下次开始查找的位置
          // 获取变量中文名
          let newStr = varStr.substring(1, varStr.length - 1);
          let newArr = newStr.split('.');
          let nodeId = newArr[0];
          let fieldName = newArr[newArr.length - 1];
          let innerHTML = '';
          for (let variable of this.editor.variableList) {
            if (nodeId == variable.nodeId) {
              innerHTML = variable.nodeName;
              for (let field of variable.children) {
                if (fieldName == field.name) {
                  innerHTML += '·' + field.nameDisp;
                  break;
                }
              }
              break;
            }
          }
          // 将变量返显为标签
          var dom = document.createElement('span');
          dom.className = 'cm-field';
          dom.innerHTML = innerHTML;
          this.codemirror.markText(
            { line, ch },
            { line, ch: index },
            {
              replacedWith: dom
            }
          );
        });
      }
      this.editor.visible = true;
    },
    editorSave() {
      if (this.editor.type == 'fieldFormula') {
        this.editor.field.fieldFormula = this.editor.value;
        this.groovyScriptSave();
      } else {
        this.formData[this.editor.type] = this.editor.value;
      }
      this.editor.show = false;
      this.editor.visible = false;
      // 后端脚本后端编译
      if (
        [
          'routeInConditionFormula',
          'preActionScriptFormula',
          'actionScriptFormula',
          'backScriptFormula',
          'backToScriptFormula'
        ].indexOf(this.editor.type) != -1
      ) {
        this.handleDefGroovyScript();
      }
    },
    // 公式编译为groovy脚本
    handleDefGroovyScript() {
      let type = this.editor.type.substring(0, this.editor.type.length - 7);
      this.osg.ajax(
        'groovyScript/handleDefGroovyScript.do',
        {
          workflowDefId: this.workflowId,
          nodeId: this.formData.nodeId,
          type: type,
          defCroovyScriptContent: this.formData[this.editor.type],
          context: JSON.stringify({
            nodeName: this.formData.name || '',
            groovyScriptId: this.formData[type + 'ScriptId'] || ''
          })
        },
        res => {
          if (res.entity) {
            this.formData[type + 'ScriptId'] = res.entity._id;
            this.$set(this.formData, type, res.entity.scriptContent);
          }
        }
      );
    },
    // 前端保存脚本
    groovyScriptSave() {
      let field = this.editor.field;
      let formName = this.options.formDefId.filter(item => {
        if (field.colName == item.colName) return item.title;
      });
      this.osg.ajax(
        'groovyScript/upsert.do',
        {
          order: 99999,
          name: `${formName}表单--"${field.name}"字段 运行时脚本`,
          scriptContent: this.editor.value,
          preAction: 1,
          annotate: '流程节点配置更改'
        },
        res => {
          this.editor.field.calculateConfig = this.osg.isJson(this.editor.field.calculateConfig)
            ? JSON.parse(this.editor.field.calculateConfig)
            : {};
          this.editor.field.calculateConfig.scriptId = res.entity._id;
          this.editor.field.calculateConfig.trigger = 'change';
          this.editor.field.calculateConfig = JSON.stringify(this.editor.field.calculateConfig);
          this.fieldSave(this.editor.field);
        }
      );
    },
    // 保存字段
    fieldSave(field) {
      this.osg.ajax('biz/extField/upsert.do', field, () => {});
    }
  }
};
</script>
<style scoped lang="scss">
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}
.page-top {
  height: 50px;
  padding: 15px;
  border-bottom: 2px solid #e5e7ed;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-content {
  padding: 15px;
  display: flex;
  overflow-y: auto;
  flex: 1;
}
.page-left {
  width: 200px;
  margin-right: 15px;
}
.page-right .page-right-form {
  /* position: fixed; */
  margin-bottom: 15px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  /* height: calc(100% - 210px); */
  /* overflow-y: auto; */
  max-width: 755px;
}
.page-right .page-right-form .form-title {
  font-weight: 600;
  padding: 10px 10px 10px 15px;
}
.page-right .page-right-form .el-form {
  padding: 0 30px;
}
.page-right .page-right-form:hover {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
/* .page-right-form:last-child {
  border: 1px solid transparent !important;
}
.page-right-form:nth-last-child(2) {
  margin-bottom: 50px !important;
} */
.page-right-btns {
  padding: 15px;
  text-align: center;
}
.node {
  width: 200px;
  height: 80px;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  background: #fff;
  border-radius: 5px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  cursor: pointer;
  position: relative;
}
.node:hover {
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.node-sort {
  position: absolute;
  bottom: -28px;
  left: calc(50% - 10px);
}
.node-sort i {
  color: #666;
  cursor: default;
}
.node-close {
  position: absolute;
  height: 16px;
  line-height: 16px;
  right: 5px;
  top: 5px;
  opacity: 0;
  z-index: -1;
  transition: all 1s linear 0s;
}
.node:hover .node-close {
  opacity: 1;
  z-index: 1;
}
.node-step {
  width: 26px;
  height: 26px;
  box-sizing: border-box;
  border: 1px solid gray;
  border-radius: 50%;
  font-size: 14px;
  text-align: center;
  transition: 0.5s;
}
.node-active {
  background-color: #f2f2f2;
}
.node-active .node-step {
  background-color: #409eff;
  border: 1px solid #409eff;
  color: #fff;
}
.node-step span {
  line-height: 26px;
}
.node-info {
  text-align: left;
  margin-left: 20px;
}
.node-name {
  font-size: 16px;
  font-weight: 700;
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.node-desc {
  color: #909399;
  margin-top: 5px;
  font-size: 14px;
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#app .el-form-item__content > div {
  width: 300px !important;
}
.el-textarea {
  width: 500px !important;
}
#app .el-form-item__content .el-transfer,
#app .el-form-item__content .formField_wrapper {
  width: 522px !important;
}
>>> .el-transfer__buttons {
  padding: 0 10px !important;
}
.workflow .c-dialog ::v-deep .el-dialog {
  min-width: 1000px !important;
}
.editor-upper {
  height: 150px;
  min-height: 150px;
  border: 1px solid #ebebeb;
  margin: 5px;
}
#app .editor-lower {
  display: flex;
  > div {
    margin: 5px;
    > div {
      margin-top: 5px;
      height: 300px;
      min-height: 300px;
      border: 1px solid #ebebeb;
    }
  }
  .editor-value {
    width: 250px;
    ::v-deep .el-input .el-input__inner {
      height: 40px;
      border: none;
    }
    > div {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      ::v-deep .el-collapse {
        flex: 1;
        overflow: auto;
      }
      ::v-deep .el-collapse-item__header {
        padding-left: 10px !important;
        padding-right: 0 !important;
        line-height: inherit;
      }
      ::v-deep .el-collapse-item__wrap {
        .editor-value-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 5px 10px;
          cursor: pointer;
          &:hover {
            background: rgba(126, 134, 142, 0.08);
          }
        }
      }
      ::v-deep .el-collapse-item__content {
        padding-bottom: 10px;
      }
      .function-name {
        height: 40px;
        line-height: 40px;
        padding-left: 10px;
        border-bottom: 1px solid #ebeef5;
      }
    }
  }
  .editor-template {
    width: 170px;
  }
}
.vue-codemirror ::v-deep .CodeMirror {
  height: 100%;
}

::v-deep {
  .cm-field {
    background-image: linear-gradient(-117deg, #90dcd4, #7cdfc2);
  }
  .cm-current-field,
  .cm-field {
    display: inline-block;
    height: 22px;
    line-height: 22px;
    color: #fff;
    margin: 0 3px;
    border-radius: 3px;
    padding: 0 8px;
    font-size: 13px;
  }
  .cm-delField {
    display: inline-block;
    height: 22px;
    line-height: 22px;
    background: #f26245;
    color: #fff;
    margin: 0 3px;
    border-radius: 3px;
    padding: 0 8px;
    font-size: 13px;
  }
  .CodeMirror-widget {
    height: 28px;
    line-height: 28px;
  }
}
</style>
<style>
.el-select-dropdown {
  max-width: 500px;
}
.form-item-sla .el-form-item__content {
  display: flex;
  align-items: center;
}
</style>
